/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, Component, Children } from 'react';
import { View } from 'react-native';
import Checkbox from './Checkbox';

type ChildList<T> = T | Array<T> | null;

type Props = {
  alignHorizontal?: boolean;
  children?: ChildList<ReactElement<typeof Checkbox>>;
  onSelectionChange?: (selectedKeys: Set<string>) => void;
  showSelectAll?: boolean;
  style?: StyleSet;
};

type State = {
  childList: Array<ReactElement<typeof Checkbox>>;
  areAllChecked: boolean;
};

class CheckboxList extends Component<Props, State> {
  state: State = {
    ...parseChildren(this.props.children),
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.children !== this.props.children) {
      this.setState({
        ...parseChildren(this.props.children),
      });
    }
  }

  render() {
    let { childList } = this.state;
    let {
      alignHorizontal,
      onSelectionChange,
      showSelectAll,
      style,
      ...otherProps
    } = this.props;
    return (
      <View {...otherProps} style={style}>
        {childList.length > 0 && showSelectAll && this._renderSelectAll()}
        <View
          style={alignHorizontal && { flexDirection: 'row', flexWrap: 'wrap' }}
        >
          {this._renderChildren()}
        </View>
      </View>
    );
  }

  _renderSelectAll = () => {
    return (
      <Checkbox
        key="selectAll"
        text="(Select All)"
        textStyle={{ fontStyle: 'italic', paddingRight: 4 } as any}
        onChange={this._onSelectAllChange}
        isChecked={this.state.areAllChecked}
      />
    );
  };

  _renderChildren = (): Array<ReactElement<typeof Checkbox>> | null => {
    let { childList } = this.state;
    return childList.map(
      (child: ReactElement<typeof Checkbox>): ReactElement<typeof Checkbox> => {
        let { key, props } = child as any;
        let onChange = () => this._onChange(String(key), !props.isChecked);
        return (
          <Checkbox
            key={key}
            isChecked={!!props.isChecked}
            text={String(props.text)}
            onChange={onChange}
            {...props}
          />
        );
      },
    );
  };

  _onSelectAllChange = () => {
    let { areAllChecked } = this.state;
    let selectedKeys = new Set<string>();
    if (!areAllChecked) {
      for (let child of this.state.childList) {
        selectedKeys.add(String(child.key));
      }
    }
    if (this.props.onSelectionChange) {
      this.props.onSelectionChange(selectedKeys);
    }
  };

  _onChange = (changedKey: string, isChecked: boolean) => {
    if (!this.props.onSelectionChange) {
      return;
    }
    let selectedKeys = new Set<string>();
    for (let child of this.state.childList) {
      let { key, props } = child as any;
      let shouldAddKey =
        key === changedKey ? isChecked : props.isChecked === true;
      if (shouldAddKey) {
        selectedKeys.add(String(key));
      }
    }
    this.props.onSelectionChange(selectedKeys);
  };
}

function parseChildren(children?: ChildList<ReactElement<typeof Checkbox>>) {
  let childList: Array<ReactElement<typeof Checkbox>> = [];
  let areAllChecked = true;
  if (children) {
    Children.forEach(children, (child: ReactElement<typeof Checkbox>) => {
      if (child.type !== Checkbox) {
        throw new Error(
          'Each child of `CheckboxList` must be of type `Checkbox`.',
        );
      }
      if (child.key == null) {
        throw new Error('Each child of `CheckboxList` must have a key.');
      }
      if (child.props && (child.props as any).isChecked !== true) {
        areAllChecked = false;
      }
      childList.push(child);
    });
  }
  return { childList, areAllChecked };
}

export default CheckboxList;
